import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import { useUser } from '~/composables/_next/useUser';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { useSegment } from '~/composables/_next/useSegment';
import { addEasiformShellScript, addContactFormScript } from '~/helpers/easiform/easiformScripts';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import { useLocalization } from '~/composables/_next/useLocalization';
export default defineComponent({
  tracking: {
    category: TrackingPageCategory.CONTACT_FORM
  },
  setup: function setup() {
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useUser = useUser(),
      user = _useUser.user;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var formID = {
      fr: 5,
      it: 6,
      en: 9,
      de: 10,
      es: 11
    };
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _useSegment, trackPage;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve) {
              resolve(addEasiformShellScript());
            });
          case 2:
            _context.next = 4;
            return addContactFormScript(locale, formID[locale], user || {});
          case 4:
            setDynamicYieldContext('OTHER', ['Contact_Us_Page']);
            window.scrollTo(0, 0);

            // TODO: Remove after Nuxt 3 migration
            _useSegment = useSegment(), trackPage = _useSegment.trackPage;
            trackPage(TrackingPageCategory.CONTACT_FORM, PageTypes.CONTACT_FORM);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    setDynamicYieldContextSSR('OTHER', ['Contact_Us_Page']);
    return {
      translate: translate,
      locale: locale,
      formID: formID
    };
  }
});